import { Lock, Check } from "lucide-react";
import { fmtP, MEGA_IMG } from "@/lib/jackpot";

export function MegaPrizes({ mega, amount }) {
  const top = mega[mega.length - 1].at;
  const pct = Math.min(100, (amount / top) * 100);
  return (
    <section className="rounded-[1.75rem] jr-panel p-5 sm:p-6" data-testid="jr-mega">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-amber-300/90">Mega-Ziele</p>
      <h2 className="font-display text-lg md:text-lg font-extrabold text-white mt-1">So viel ist der Jackpot wert</h2>
      <div className="mt-5 relative h-3 rounded-full bg-white/10 overflow-visible" data-testid="jr-mega-track">
        <div className="h-full rounded-full jr-gold-fill transition-[width] duration-1000" style={{ width: `${Math.max(pct, 2)}%` }} />
        {mega.map((m) => (
          <span key={m.key} className={`absolute -top-1.5 w-6 h-6 -ml-3 rounded-full border-2 flex items-center justify-center ${amount >= m.at ? "bg-amber-300 border-amber-100" : "bg-[#12040d] border-amber-300/50"}`} style={{ left: `${(m.at / top) * 100}%` }}>
            {amount >= m.at ? <Check className="w-3.5 h-3.5 text-[#4a2a08]" strokeWidth={3} /> : <Lock className="w-3 h-3 text-amber-200/70" />}
          </span>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3">
        {mega.map((m) => {
          const ok = amount >= m.at;
          return (
            <div key={m.key} className={`relative overflow-hidden rounded-2xl aspect-[4/5] ${ok ? "ring-2 ring-amber-300 jr-unlocked" : "ring-1 ring-white/10"}`} data-testid={`jr-mega-${m.key}`} data-unlocked={ok || undefined}>
              <img src={MEGA_IMG[m.key]} alt={m.label} className={`absolute inset-0 w-full h-full object-cover transition-[filter,transform] duration-700 ${ok ? "" : "grayscale-[.65] brightness-50"}`} loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-3">
                <p className="font-display font-extrabold text-white text-sm leading-tight">{m.label}</p>
                <p className="text-[11px] font-bold text-amber-300">ab {fmtP(m.at)} Punkten</p>
                <p className="mt-1 text-[10px] font-semibold text-white/70">{ok ? "Erreicht! 🔥" : `noch ${fmtP(m.at - amount)}`}</p>
              </div>
            </div>
          );
        })}
      </div>
      <p className="mt-4 text-xs text-white/60">Ausgezahlt wird in Punkten – die tauschst du im Prämien-Shop gegen deine Wunschprämie ein.</p>
    </section>
  );
}
